module.exports = __webpack_public_path__ + "2d1068a7f51e1fc2c63d81165bf52422.ttf";